// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FitnessBackground_wrapper__P0EZI","heading":"FitnessBackground_heading__3DYA7","list":"FitnessBackground_list__22Rnx"};